// Adds transition classes to notification, fades to 0 opacity and then hides from dom on transition finish
import { getQueryParameters } from "./url-query-to-cookie";

function fadeOutNotification(form) {
    let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');

    for (let notification of notifications) {
        notification.classList.add('transition-opacity', 'duration-500', 'delay-[15000ms]', 'flex', 'items-center');

        setTimeout(() => {
            notification.classList.add('opacity-0');
        }, 50);

        notification.addEventListener('transitionend', event => {
            notification.classList.add('hidden');
        }, { once: true });
    }
}

export function handleFreeformError(form) {
    let notifications = form.querySelectorAll('.ff-form-errors, .ff-form-success');
    let submitButton = form.querySelector('button[data-freeform-action="submit"]');
    let prevButton = form.querySelector('button[data-freeform-action="back"]');

    for (let notification of notifications) {
        if (prevButton) {
            prevButton.closest('.freeform-column').insertBefore(notification, prevButton);
            fadeOutNotification(form);
        } else {
            submitButton.closest('.freeform-column').insertBefore(notification, submitButton);
            fadeOutNotification(form);
        }
    }
}

window.addEventListener('load', event => {

    // Function that pushes GA data through to datalayer for GTM
    // ...additional datalayer data can be added at time of form submission
    function gtmPush(event, formId, additional = {}) {
        if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
                event: event,
                formName: formId,
                ...(additional ?? {})
            });
        }
    }

    function getHiddenFieldValue(fieldName) {
        let value = Cookies.get(fieldName);

        if (!value) {
            const queryVals = getQueryParameters();
            if (queryVals.hasOwnProperty(fieldName)) {
                value = queryVals[fieldName];
            } else {
                value = '';
            }
        }

        return value;
    }

    // Function that sets field values based on cookies etc.
    function setFormValues(form) {

        // Array of form fields and the new value that should be assigned to that field
        let formFields = [
            {
                handle: form.utmSource,
                newValue: getHiddenFieldValue('utm_source')
            },
            {
                handle: form.utmMedium,
                newValue: getHiddenFieldValue('utm_medium')
            },
            {
                handle: form.utmCampaign,
                newValue: getHiddenFieldValue('utm_campaign')
            },
            {
                handle: form.utmContent,
                newValue: getHiddenFieldValue('utm_content')
            },
            {
                handle: form.gaclientid,
                newValue: getHiddenFieldValue('_ga')?.slice(6)
            },
            {
                handle: form.gatrackid,
                newValue: typeof google_tag_manager === 'object' ? Object.keys(google_tag_manager).filter((key) => key.indexOf('G-') === 0) : ''
            },
            {
                handle: form.gclid,
                newValue: getHiddenFieldValue('ff_gclid')
            },
            {
                handle: form.fbClickId,
                newValue: getHiddenFieldValue('_fbc')
            },
            {
                handle: form.fbBrowserId,
                newValue: getHiddenFieldValue('_fbp')
            },
            {
                handle: form.pageUrl,
                newValue: window.location
            },
            {
                handle: form.pageTitle,
                newValue: form.dataset.pageTitle
            },
            {
                handle: form.pageDivision,
                newValue: form.dataset.pageDivision
            }
        ]

        // Assign form fields new values if they exist
        for (let field of formFields) {
            if (field.handle && field.newValue) {
                field.handle.value = field.newValue;
            }
        }
    }

    // Freeform functions
    let forms = document.querySelectorAll('form');

    for (let form of forms) {
        const formId = form.id;

        // Override Freeform default error/success message
        // Commented as should be set on form via cms, but could be useful for a dynamic message on a reusable form
        // freeform.setOption('errorBannerMessage', 'Error!');
        // freeform.setOption('successBannerMessage', 'Success!');

        // Runs when freeform has attempted a submission
        form.addEventListener('freeform-on-submit', function (event) {

            // Calls function to set dynamic field values
            setFormValues(form);
        });

        // Runs after ajax submit
        form.addEventListener('freeform-ajax-after-submit', function(event) {
            // Override error/success notification position on ajax submission
            handleFreeformError(form);
        });

        // Runs before ajax submit
        form.addEventListener('freeform-ajax-before-submit', function(event) {
            // Adds any additional requirements to GA data
            // payload = form data after 'freeform-on-submit' has run
            // payload.get('field handle') = associated value of that field handle
            const payload = event.data;

            form.dataLayerSubmission = {
                enquiryFormData: {
                    gaFormName: payload.get('gaformname'),
                }
            };

            // Get 'howDidYouHearAboutUs'
            const hearAboutUs = payload.get('howDidYouHearAboutUs');
            if (hearAboutUs) {
                form.dataLayerSubmission['formHeardAbout'] = hearAboutUs;
            }

            // Get 'fullname'
            const fullName = payload.get('fullname');
            if (fullName) {
                form.dataLayerSubmission['fullName'] = fullName;

                // Split full name into first and last name
                const nameParts = fullName.trim().split(' ');
                const firstName = nameParts[0];
                const lastName = nameParts.slice(1).join(' ') || '';

                form.dataLayerSubmission['firstName'] = firstName;
                form.dataLayerSubmission['lastName'] = lastName;
            }

            // Get 'email'
            const email = payload.get('email');
            if (email) {
                form.dataLayerSubmission['email'] = email;
            }

            // Get 'contactNumber'
            const contactNumber = payload.get('contactNumber');
            if (contactNumber) {
                form.dataLayerSubmission['phone'] = contactNumber;
            }
        });

        // Runs after successful ajax submission
        form.addEventListener('freeform-ajax-success', function(event) {
            let formContainer = form.closest('div[data-form-complete]');

            if (formContainer) {
                formContainer.dataset.formComplete = 'true';
                setTimeout(() => {
                    formContainer.dataset.formComplete = 'false';
                }, 10000);
            }

            // Pushes GA data through to datalayer
            gtmPush('formSubmitted', formId, form.dataLayerSubmission);
        });
    }
});